export const FEATURE_FLAGS = {
    //TO-DO: remove after first actual ff use. This one is only for the reference
    test_ff: 'test-feature-toggle',
    postResults_ff: 'post-results-ff',
};
